import type { Locale } from "../i18n/locale";
import { clipUrlFor } from "./audioClips";
import { clipUrlForFR } from "./audioClips.fr";
import { clipUrlForEL } from "./audioClips.el";
import { clipUrlForNL } from "./audioClips.nl";

/** Per-locale clip resolvers, each generated from the audio repo. */
const RESOLVERS: Record<Locale, (id: string | undefined, phrase: string) => string | null> = {
  en: clipUrlFor,
  fr: clipUrlForFR,
  el: clipUrlForEL,
  nl: clipUrlForNL,
};

/**
 * The pre-generated clip for this exact phrase, or null when there is none (the
 * caller then falls back to the browser voice).
 *
 * Clips are keyed by the PHRASE, and a phrase already carries its own language.
 * So when a drawing hasn't been translated yet, the French app shows — and
 * speaks — the English line, and the English clip is the correct audio for it.
 * Falling back to English is therefore not "playing the wrong language": it is
 * the only recording of the words actually on screen. A French phrase can never
 * hit it by accident, because its slug won't match an English one, which is what
 * keeps the build gate honest about genuinely missing French clips.
 */
export function clipUrl(
  locale: Locale,
  drawingId: string | undefined,
  phrase: string,
): string | null {
  return RESOLVERS[locale](drawingId, phrase) ?? clipUrlFor(drawingId, phrase);
}
